function CaravanRetrieveSavedQuoteResponseTransformer($filter, jsonMapper,Util) {
    // transform functions
    var transformers = {
        camelcase: function(value) {
            if(value) {
                return value.charAt(0).toUpperCase() + value.slice(1);
            }
        },
        minimumTodaysDate: function(dateString) {
            var date = moment(dateString, 'YYYY-MM-DD')
                , today = new moment()
                , biggerDate = date >= today ? date : today ;

            return biggerDate.format('DD/MM/YYYY');
        }
        ,date: function(dateString) {
            var date = moment(dateString, 'YYYY-MM-DD') ;
            return date.format('DD/MM/YYYY') ;
        },
        financeType: function(financeType) {
            switch(financeType) {
                case 'none':
                    return '';
                    break;
            }
        },
        convertGender: function(gender) {
            var gc = {
                M : 'male',
                F : 'female',
                I : 'intersex',
            };
            return gc[gender] ;
        },
        convertUnit: function(unit) {
            var gc = {
                'ft' : 'feet',
                'm' : 'metres'
            };
            return gc[unit] ;
        },
        convertSpecifiedCategory: function(category) {
            var gc = {
                'camping_equipment' : 'Camping Equipment',
                'commnav_equipment' : 'Communication and Navigation Equipment',
                'electrical_equipment' : 'Electrical Equipment',
                'entertain_equipment' : 'Entertainment Equipment',
                'other' : 'Other',
                'sporting_equipment' : 'Sporting Equipment'

            };
            return gc[category] ;
        },
        yesNo: function(value) {
            return value == 'yes' ? true : false;
        },
        checkbox: function(value) {
        },
        state: function(state) {
            if ( state )
                return state.replace('AU_', '');
        },
        coverType: function(coverType) {
            if(coverType === 'third_party' || coverType === 'third_party_fire_theft') {
                return 'third_party';
            }
            return coverType;
        },
        purchaseMonthFromMonthYear: function(monthYear) {
            if(monthYear){
                return monthYear.split('-')[1];
            }else{
                return '';
            }

        },
        purchaseYearFromMonthYear: function(monthYear) {
            if(monthYear){
                return monthYear.split('-')[0];
            }else{
                return '';
            }
        },
        thirdPartyPref: function(coverType) {
            if(coverType === 'comprehensive') {
                return null;
            }
            return coverType;
        },
        convertToLabelValue: function(o) {
            if ( o )
                return {
                    label : o.name,
                    value : o.code,
                }

            return null;
        },
        yearsHeld: function(years) {
            var yearsHeld;

            switch (years) {
                case '7':
                    yearsHeld = 'lessThan_1';
                    break;
                case '6':
                    yearsHeld = 'greaterThan_5';
                    break;
                default:
                    yearsHeld = years;
            }

            return yearsHeld;
        }
    };
    function transformPerson(person) {
        var transformMapping = {
                'returnObject.title':                                   '=_input.prefix',
                'returnObject.firstName':                               '=_input.firstName',
                'returnObject.lastName':                                '=_input.lastName',
                'returnObject.gender':                                  '=_input.gender',
                'returnObject.dateOfBirth':                             '=_input.dateOfBirth'
            },
            convertMapping = {
                'returnObject.title':                                   transformers.camelcase,
                'returnObject.gender':                                  transformers.convertGender,
                'returnObject.dateOfBirth':                             transformers.date
            };
        var transformedPerson = jsonMapper.convert(jsonMapper.transform(person, transformMapping), convertMapping);
        return transformedPerson.returnObject;
    }

    function transformDriver(driver) {
        var transformMapping = {
            'returnObject.yearsHeld':                                               '=_input.driver.yearsLicenced',
            'returnObject.licenceType':                                             '=_input.driver.licenceType',
            'returnObject.noClaimBonus':                                            '=_input.driver.noClaimBonus',
            'returnObject.previousInsurer':                                         '=_input.driver.currentInsurer',
            'returnObject.licensedToRide':                                          '=_input.licensedToRide',
            'returnObject.threeYears_accidentsClaims':                              '=_input.driver.hasClaim',
            'returnObject.fiveYears_chargedOrConvicted':                            '=_input.driver.hasConviction',
            'returnObject.threeYears_restrictedSuspendedDisqualifiedCancelled':     '=_input.driver.hasLostLicence',
            'returnObject.visaType':                                                '=_input.driver.visaType',
            },
            convertMapping = {
                'returnObject.yearsHeld':                                           transformers.yearsHeld,
                'returnObject.licensedToRide':                                      transformers.yesNo,
                'returnObject.threeYears_accidentsClaims':                          transformers.yesNo,
                'returnObject.fiveYears_chargedOrConvicted':                        transformers.yesNo,
                'returnObject.threeYears_restrictedSuspendedDisqualifiedCancelled': transformers.yesNo
            };

        var mappedRider = jsonMapper.transform(driver, transformMapping);
        var transformedRider = jsonMapper.convert(mappedRider, convertMapping);
        var returnObject = transformedRider.returnObject;
        if(driver.driver.person) {
            transformedRider.returnObject.person = transformPerson(driver.driver.person);
        }

        // extract driver history
        returnObject.fourYears_chargedOrConvictedOffencesDetails = [];
        returnObject.fourYears_vehicleAccidentsClaimsDetails = [];
        returnObject.tenYears_chargedOrConvictedOffencesDetails = [];
        returnObject.fourYears_licenceRSDCDetails = [];

        if (!!driver.driver.driverHistory) {
            driver.driver.driverHistory.forEach(function(record) {
                var matchedPattern = {};

                switch (record.pattern.filter1) {
                    case 'infringement_demerit':
                    // case 'infringement_licence':
                        returnObject.fourYears_chargedOrConvictedOffencesDetails.push(
                            extractHistory(globals.fourYears_offences.options, record)
                        );
                        break;
                    case 'infringement_licence':
                        returnObject.fourYears_licenceRSDCDetails.push(
                            extractHistory(globals.incidents.options, record)
                        );
                        break;
                    case 'claim' :
                        returnObject.fourYears_vehicleAccidentsClaimsDetails.push(
                            extractHistory(globals.accidents.options, record));
                        break;
                    case 'conviction' :
                        returnObject.tenYears_chargedOrConvictedOffencesDetails.push(
                            extractHistory(globals.tenYears_offences.options, record)
                        );
                        break;

                }
            });
        }

        returnObject.fourYears_chargedOrConvictedOffences = returnObject.fourYears_chargedOrConvictedOffencesDetails.length > 0 ;
        returnObject.fourYears_vehicleAccidentsClaims = returnObject.fourYears_vehicleAccidentsClaimsDetails.length > 0 ;
        returnObject.tenYears_chargedOrConvictedOffences = returnObject.tenYears_chargedOrConvictedOffencesDetails.length > 0 ;
        returnObject.fourYears_licenceRSDC = returnObject.fourYears_licenceRSDCDetails.length > 0 ;

        return returnObject;
    }

    function extractHistory(collection, record) {
        var matchedPattern = {};
        var month = {};
        var year = {};

        matchedPattern = collection.find(function(opt) {
            return opt.publicID == record.pattern.publicID;
        });

        month.label = month.value = moment(record.month, 'MM').format('MMMM') ; // Util.capitalize(record.month.toString());
        year.label = year.value = Util.capitalize(record.year.toString());

        record.description = matchedPattern;
        record.month = month;
        record.year = year;

        delete record.pattern;

        return record;
    }

    function transformPolicyHolder(holder) {

        var transformMapping = {
            'returnObject.title':                                           '=_input.prefix',
            'returnObject.firstName':                                       '=_input.firstName',
            'returnObject.lastName':                                        '=_input.lastName',
            'returnObject.gender':                                          '=_input.gender',
            'returnObject.dateOfBirth':                                     '=_input.dateOfBirth',
            'returnObject.fourYears_chargedOrConvictedOffences':            '=_input.hasConviction',
            'returnObject.fourYears_licenceRSDC':                           '=_input.hasLostLicence',
            'returnObject.fourYears_vehicleAccidentsClaims':                '=_input.hasClaim',
            'returnObject.tenYears_chargedOrConvictedOffences':             '=_input.hasInfringement'
            },
            convertMapping = {
                'returnObject.title':                                       transformers.camelcase,
                'returnObject.gender':                                      transformers.convertGender,
                'returnObject.dateOfBirth':                                 transformers.date,
                'returnObject.fourYears_chargedOrConvictedOffences':        transformers.yesNo,
                'returnObject.fourYears_licenceRSDC':                       transformers.yesNo,
                'returnObject.fourYears_vehicleAccidentsClaims':            transformers.yesNo,
                'returnObject.tenYears_chargedOrConvictedOffences':         transformers.yesNo
            };

        var transformedPolicyHolder = jsonMapper.convert(jsonMapper.transform(holder, transformMapping), convertMapping);

        return transformedPolicyHolder.returnObject;
    }

    /**
     * Transforms the retrievedQuoteRepsonse into a format that can be injected into the userInputRepository
     * The returned value will populate all the forms in the quote process
     * @param {Object} retrievedQuoteResponse                   Response object from the retrieveSavedQuote service
     * @returns {Object}                                        Transformed object ready to inject into the userInputRepository
     */
    function transform(retrievedQuoteResponse) {
    	console.info('retrievedQuoteResponse', retrievedQuoteResponse);

       var transformMapping = {
				'returnObject.email': '=_input.email',

				// getStarted
				'returnObject.getStarted.policyStartDate':
					'=_input.periodStartDate',

				// aboutYourCaravan
				'returnObject.aboutYourCaravan.vehicleType':
					'=_input.caravans.0.caravanType',
				'returnObject.aboutYourCaravan.address':
					'=_input.caravans.0.garageAddress',

				// caravanDetails
				'returnObject.caravanDetails.vehicleSubType':
					'=_input.caravans.0.caravanSubType',
				'returnObject.caravanDetails.isCaravanRegistered':
					'=_input.caravans.0.isCaravanRegistered',
				'returnObject.caravanDetails.regoNumber':
					'=_input.caravans.0.registrationNumber',
				'returnObject.caravanDetails.locationDescription':
					'=_input.caravans.0.locationType',
				'returnObject.caravanDetails.security':
					'=_input.caravans.0.securityType',
				'returnObject.caravanDetails.primaryUse':
					'=_input.caravans.0.caravanUsageType',
				'returnObject.caravanDetails.existingDamage':
					'=_input.caravans.0.existingDamageType',
				'returnObject.caravanDetails.finance':
					'=_input.caravans.0.financeType',
				'returnObject.caravanDetails.financeWith':
					'=_input.caravans.0.financeCompany',
				'returnObject.caravanDetails.whenDidYouBuyYear':
					'=_input.caravans.0.purchaseMonthYear',
				'returnObject.caravanDetails.whenDidYouBuyMonth':
					'=_input.caravans.0.purchaseMonthYear',
				'returnObject.caravanDetails.purchasePrice':
					'=_input.caravans.0.purchasePrice',
				'returnObject.caravanDetails.cost':
					'=_input.caravans.0.purchasePrice',
				'returnObject.caravanDetails.isPremanentResidence':
					'=_input.caravans.0.isPermResidence',
				'returnObject.caravanDetails.nonRetractableJacksorPermanantFoundations':
					'=_input.caravans.0.isCaravanOnNonRetractableJacks',
				'returnObject.caravanDetails.permanentlyConnected':
					'=_input.caravans.0.isCaravanConnectedToPlumbing',

				// aboutYourContents
				'returnObject.aboutYourContents.insureContents':
					'=_input.caravans.0.contentsCover',
				'returnObject.aboutYourContents.generalContentsValue':
					'=_input.caravans.0.contentsCoverAmount',
				'returnObject.aboutYourContents.contentsItems':
					'=_input.caravans.0.specifiedItems',

				// quote excess and sum insured values
				'returnObject.sumInsured.agreedValue':
					'=_input.caravans.0.agreedAmountValue',
				'returnObject.sumInsured.annexeReplacementCost':
					'=_input.caravans.0.replacementCostValue',
				'returnObject.excess.voluntaryVehicleExcess':
					'=_input.caravans.0.excess.voluntaryVehicleExcess',

				//tell us a bit more -------------------------------------
				'returnObject.tellUsABitMore.yourEmailAddress': '=_input.email',
				'returnObject.tellUsABitMore.promotionalCode':
					'=_input.campaignCode',
				'returnObject.stampDutyExemption.isSmallBusiness':
					'=_input.caravans.0.isSmallBusiness',
				//driver
				// 'vehicleForm.driver.paymentOptions':             '=_input.?',

				// optional benefits
				// 'returnObject.discountOptions.discountLayup':               '=_input.caravans.0.coverageOptions.0.activeLayupMonths',

				// registration details
				'returnObject.caravanInfo': '=_input.caravans.0.caravanInfo',
				'returnObject.retrievedQuoteRego.rego':
					'=_input.caravans.0.registrationNumber',
				'returnObject.retrievedQuoteRego.state':
					'=_input.caravans.0.garageAddress.state',

				// Contact
				'returnObject.mainPolicyHolderContact.passwordQuestion':
					'=_input.policyHolders.0.contact.passwordQuestion',
				'returnObject.mainPolicyHolderContact.passwordAnswer':
					'=_input.policyHolders.0.contact.passwordAnswer',
				'returnObject.mainPolicyHolderContact.primaryPhone':
					'=_input.policyHolders.0.contact.primaryPhone',
				'returnObject.mainPolicyHolderContact.personalContactDetailsMailingPreference':
					'=_input.documentDeliveryMethod'
			},
			convertMapping = {
				'returnObject.getStarted.policyStartDate':
					transformers.minimumTodaysDate,
				'returnObject.caravanDetails.whenDidYouBuyYear':
					transformers.purchaseYearFromMonthYear,
				'returnObject.caravanDetails.whenDidYouBuyMonth':
					transformers.purchaseMonthFromMonthYear,
				'returnObject.caravanDetails.financeWith':
					transformers.convertToLabelValue
			};

        var transformedQuote = jsonMapper.convert(jsonMapper.transform(retrievedQuoteResponse, transformMapping), convertMapping);

        var returnObject = transformedQuote.returnObject;
        // set comprehensive preference to null if the coverType is third party
        console.info(retrievedQuoteResponse);
        // set primary phone number to mobile phone
        if(retrievedQuoteResponse.policyHolders[0].contact.cellPhone) {
            returnObject.mainPolicyHolderContact.primaryPhoneNumber = retrievedQuoteResponse.policyHolders[0].contact.cellPhone;
        }

        // set primary phone number to home phone
        if(retrievedQuoteResponse.policyHolders[0].contact.homePhone) {
            returnObject.mainPolicyHolderContact.primaryPhoneNumber = retrievedQuoteResponse.policyHolders[0].contact.homePhone;
        }

        // set primary phone number to work phone
        if(retrievedQuoteResponse.policyHolders[0].contact.workPhone) {
            returnObject.mainPolicyHolderContact.primaryPhoneNumber = retrievedQuoteResponse.policyHolders[0].contact.workPhone;
        }        

        if ( returnObject.caravanInfo && returnObject.caravanInfo.vgiId ){
            returnObject.aboutYourCaravan.searchType = 'yearMakeModel' ;
            returnObject.aboutYourCaravan.vgiId = returnObject.caravanInfo.vgiId;
            // returnObject.aboutYourCaravan.vehicleKey = returnObject.caravanInfo.
            returnObject.aboutYourCaravan.description= 'returnObject.caravanInfo.';
            returnObject.aboutYourCaravan.modelYear= returnObject.caravanInfo.modelYear;
            returnObject.aboutYourCaravan.make= returnObject.caravanInfo.make;
            returnObject.aboutYourCaravan.model= returnObject.caravanInfo.model;
            returnObject.aboutYourCaravan.bodyStyle= returnObject.caravanInfo.bodyType;
            returnObject.aboutYourCaravan.ratingGrade= 'returnObject.caravanInfo.';
            returnObject.aboutYourCaravan.weight= returnObject.caravanInfo.weight;

        } else {
            if(returnObject.caravanInfo){
                returnObject.aboutYourCaravan.searchType = 'manually' ;
                returnObject.aboutYourCaravan.year= ''+returnObject.caravanInfo.modelYear;
                returnObject.aboutYourCaravan.make= returnObject.caravanInfo.make;
                returnObject.aboutYourCaravan.model= returnObject.caravanInfo.model;
                returnObject.aboutYourCaravan.bodyType= returnObject.caravanInfo.bodyType;
                returnObject.aboutYourCaravan.berths= parseInt(returnObject.caravanInfo.berths);
                returnObject.aboutYourCaravan.weight= parseInt(returnObject.caravanInfo.weight);
                returnObject.aboutYourCaravan.manualLength= parseInt(returnObject.caravanInfo.caravanLength);
                returnObject.aboutYourCaravan.manualLengthUnits= transformers.convertUnit(returnObject.caravanInfo.lengthUnits);
                returnObject.aboutYourCaravan.customBuilt= returnObject.caravanInfo.customBuilt;
                returnObject.aboutYourCaravan.numOfAxels= returnObject.caravanInfo.numberOfAxles;
            }

        }

        // region Sort drivers to put mainRider first in the list
        if(retrievedQuoteResponse.caravans && retrievedQuoteResponse.caravans.length && retrievedQuoteResponse.caravans[0].drivers) {
            var drivers = $filter('orderBy')(retrievedQuoteResponse.caravans[0].drivers, function(driver) {
                return driver.driverUsage == 'main' ? 0 : 1;
            });
            transformedQuote.returnObject.driver = {};
            transformedQuote.returnObject.driver.drivers = [];
            drivers.forEach(function(driver, index) {
                transformedQuote.returnObject.driver.drivers.push(transformDriver(driver));
            });
            
            //dd-1040-extend driver object to reflect data
            if(transformedQuote.returnObject.driver && transformedQuote.returnObject.driver.drivers[0]){
                var years = retrievedQuoteResponse.caravans[0].yearsContinuousInsurance == '4'? '3+' : parseInt(retrievedQuoteResponse.caravans[0].yearsContinuousInsurance);
                var claims = Object.extend(transformedQuote.returnObject.driver.drivers[0], {yearsContinuousInsurance: years,
                        timeSinceLastClaim: retrievedQuoteResponse.caravans[0].timeSinceLastClaim});
            }
        }

        //add content items
        if(returnObject.aboutYourContents && returnObject.aboutYourContents.contentsItems){
            returnObject.aboutYourContents.contentsItems.forEach(function(item){
                var _label = transformers.convertSpecifiedCategory(item.category);
                var _category = {'label' : _label, 'value' : item.category };
                item.category = _category;
            });
        }

        if(retrievedQuoteResponse.caravans[0].caravanUsageType) {
            var usage = retrievedQuoteResponse.caravans[0].caravanUsageType;
			switch (usage) {
				case 'commercial':
                transformedQuote.returnObject.caravanDetails.commercialActivityType = retrievedQuoteResponse.caravans[0].businessUsageType;
					break;
				case 'business':
                    transformedQuote.returnObject.caravanDetails.businessActivityType = retrievedQuoteResponse.caravans[0].businessUsageType;
					break;
			}            
        }        

        // "category":{"label":"Electrical Equipment","value":"electrical_equipment"}

        // convert discount layups
        // convertDiscountLayups: function(list) {
        //     var rekeyedObject = {} ;

        //     angular.forEach(list, function(value, index) {
        //         rekeyedObject[value] = true ;
        //     });

        //     return rekeyedObject ;
        // }


        // set optional benefits
        // if(retrievedQuoteResponse.vehicles[0].coverageOptions.length) {
        //  var coverageOptions = retrievedQuoteResponse.vehicles[0].coverageOptions;
        //  coverageOptions.forEach(function(option, index) {
        //      console.info(option);
        //  })
        // }

        // set about your content section for items over $750

        // set contact policy holders
        // if(retrievedQuoteResponse.policyHolders && retrievedQuoteResponse.policyHolders.length) {
        //     var policyHolders = retrievedQuoteResponse.policyHolders;
        //     transformedQuote.returnObject.mainPolicyHolder = {};
        //     policyHolders.forEach(function(holder, index) {
        //         if(holder.mainHolder) {
        //             transformedQuote.returnObject.mainPolicyHolder.mainPolicyHolder = true;
        //             transformedQuote.returnObject.mainPolicyHolder = transformPolicyHolder(holder.contact);
        //             transformedQuote.returnObject.mainPolicyHolder.policyHolders = [];
        //         } else {
        //             transformedQuote.returnObject.mainPolicyHolder.policyHolders.push(transformPolicyHolder(holder.contact));
        //         }
        //     });
        // }

        console.info('final transform quote', transformedQuote.returnObject);

        return transformedQuote.returnObject;
    }
    return {
        transform: transform
    }
}
